import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import '../../../TestPerformanceAnalysis/styles.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { isEmpty } from 'lodash';
import useWindowDimensions from '../../../../../components/Dimension';

export default function SolutionImageSlider(props) {
  const listQuestion = props.listQuestion;
  const sliderRef = useRef(null);
  const divRef = useRef(null);
  //window height
  const { height } = useWindowDimensions();
  const next = () => {
    sliderRef.current.slickNext();
    divRef.current.scrollIntoView();
  };
  const prev = () => {
    sliderRef.current.slickPrev();
    divRef.current.scrollIntoView();
  };

  useEffect(() => {
    if (!isEmpty(listQuestion)) sliderRef.current.slickGoTo(0);
  }, [listQuestion]);

  const getQuestionSolutionSlider = () => {
    const sliderImage = [];
    var settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      adaptiveHeight: true,
      fade: true
    };
    listQuestion && listQuestion.map((data, index) => {
      return sliderImage.push(
        <div className="slide" key={index}>
          <div className="counts" ref={divRef}>
            <span className="q-count">{data.QuestionNo}</span>
            {/* <span className="q-count">{index + 1}</span> */}
            <span className="q-total ml-10">
              {' '}
              of{' '}
              {parseInt(listQuestion[0].QuestionNo) + listQuestion.length - 1}
            </span>
          </div>
          <div className="question-slide">
            <img
              src={data.SolutionImage}
              alt={data.QuestionNo}
              className="img-responsive"
            />
          </div>
        </div>
      );
    });

    return (
      <Slider ref={sliderRef} {...settings}>
        {sliderImage}
      </Slider>
    );
  };

  return (
    <React.Fragment>
      <div className="slider-wrapper" style={{ height: height - 270 }}>
        <PerfectScrollbar>
          {listQuestion && listQuestion.length > 0 && getQuestionSolutionSlider()}
        </PerfectScrollbar>
      </div>

      <div className="footer-container">
        <Button
          variant="contained"
          className="footer-buttons"
          onClick={() => prev()}
        >
          <ArrowBackIosIcon style={{ fontSize: 12 }} /> Previous
        </Button>
        <Button
          variant="contained"
          className="footer-buttons"
          onClick={() => next()}
        >
          Next <ArrowForwardIosIcon style={{ fontSize: 12 }} />
        </Button>
      </div>
    </React.Fragment>
  );
}
SolutionImageSlider.propTypes = {
  listQuestion: PropTypes.object || PropTypes.array
};
